const installPurchaseOrder = require('./purchaseOrder/installClient')

module.exports = installPurchaseOrder
